import React from 'react'
import { withRouter } from 'react-router-dom'
import {
    withStyles,
    Avatar,
    Grid,
    Link,
    IconButton,
    InputBase,
    Paper,
    Button,
    ClickAwayListener,
} from '@material-ui/core'
import {Search} from '@material-ui/icons'

import {withApollo} from 'react-apollo'
import {getUsername, getUserId, isSessionUser} from '../../../utility/function'
import {GET_USER_PROFILE} from '../../../api/graphql'
import UserAvatar from '../../common/userAvatar'
import frontpageConstants from '../../../page/frontpage/constants.json';
import EE from '../../../api/eventemitter'
import { unfocusInputField } from '../../../utility/unfocus-input-field.ts';
import logo from '../../../element/2024feb/logo2024.png'
import tempSiteLogo from '../../../element/2026/tempSiteLogo.png'
import { appConfig } from '../../../app/app.config'

const styles = {
    panel: {
        position:"-webkit-sticky",
        position:"sticky",
        top:"0",
        width:"100%",
        height:"4rem",
        padding:"0",
        background:"#FFF",
        zIndex:"10"
    },
    // Logo cell. On the dashboard it's grey to align with the left column (one continuous
    // left strip); everywhere else it stays white. Width matches the left column (xs=2).
    logoCell:{
        background:"#F8F8F8",
        height:"100%",
        display:"flex",
        alignItems:"center",
        paddingLeft:"1rem",
    },
    logoCellPlain:{
        background:"transparent",
        height:"100%",
        display:"flex",
        alignItems:"center",
        paddingLeft:"1rem",
    },
    // "Play, Create." tagline, shown inline with the search input (main site only).
    taglineInline:{
        fontFamily:"arial",
        fontWeight:"bold",
        fontSize:"20px",
        color:"#F35D4A",
        marginRight:"1rem",
        whiteSpace:"nowrap",
    },
    // Search input + ABOUT, centered on the whole panel (page center) regardless of the
    // asymmetric logo/right columns.
    searchCenter:{
        position:"absolute",
        left:"50%",
        top:"50%",
        transform:"translate(-50%, -50%)",
        display:"flex",
        alignItems:"center",
        zIndex:1,
    },
    logo:{
        background:"#4173D6",
        color:"#FFF",
    },
    searchBar: {
        display: 'inline-flex',
        margin:"0 0.6rem 0 0",
        alignItems: 'center',
        width: "300px",
        boxShadow:"none",
        background:"#FAF7EA",
        border:"1px solid #D1D1D1",
    },
    searchInput: {
        padding:"0 5px",
        flex:1
    },
    searchIcon: {
        padding:"5px",
    },
    tagline:{
        fontSize: "20px"/*'0.875rem'*/,
        margin:"0 1rem",

    },
    links:{
        fontSize:"12px",
        display:"inline",
        color:"#4F4F4F",
        margin:"0 0 0 2em",
    },

    logIn:{
        border:"1px solid #d1d1d1",
        color:"#4F4F4F",
        marginRight:"1em",
        outline:"none"
    },
    signUp:{
        background:"#FFAA0D",
        color:"#fff",
        marginRight:"1em",
        outline:"none"
    },

    logout: {
        border:"1px solid #d1d1d1",
        color:"#4F4F4F",
        marginRight:"1em",
        outline:"none"
    },

    avatar:{
        marginRight:"1em"
    }

}

class GameTopPanel extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            loggedIn : "true",
            searchString: "",
            anchorEl: null,
            redirect: null,
            avatar: null
        }
    }

    componentDidMount(){
        EE.on("Avatar updated", this.handleAvatarUpdated)
        this.loadAvatar()
    }

    componentDidUpdate(){
        // the session is read asynchronously, so the user may only become available after mount
        if(!this.avatarRequested){ this.loadAvatar() }
    }

    loadAvatar = () => {
        if(isSessionUser() !== true){ return }
        this.avatarRequested = true
        this.props.client.query({
            query: GET_USER_PROFILE,
            variables: {_id: getUserId()},
            fetchPolicy: "network-only",
        }).then((res)=>{
            const u = res && res.data && res.data.userById
            if(u && !this.unmounted){ this.setState({avatar: u.avatar || null}) }
        }).catch((err)=>{
            this.avatarRequested = false
            console.error("top bar avatar load failed:", err)
        })
    }

    componentWillUnmount(){
        this.unmounted = true
        EE.removeListener("Avatar updated", this.handleAvatarUpdated)
    }

    handleAvatarUpdated = (avatar) => {
        if(!this.unmounted){ this.setState({avatar}) }
    }

    render(){
        const {classes, reqLogin} = this.props
        const isLoggedIn = isSessionUser();

        return(
            <Grid container className={classes.panel} justifyContent="flex-start" alignItems="center" >
                <Grid item xs={2} className={this.props.dashboard ? classes.logoCell : classes.logoCellPlain}>
                    <a href="/" style={{textDecoration:"none", fontFamily: 'Covered By Your Grace', color:"#4173D6", display:"inline", fontWeight:"bold", fontSize:"26px", margin:"0"}}>
                        {appConfig.isTempSite ? (
                            // Temp site: neutral branding — just the temp logo.
                            <img src={tempSiteLogo} style={{height:"46.76px"}}/>
                        ) : (
                            <img src={logo} style={{width:"121px", height:"46.76px"}}/>
                        )}
                    </a>

                </Grid>
                <Grid item xs={7} style={{ position: "relative" }}>
                    {/* "Play, Create." is pinned to the left (2rem) so it lines up with the
                        dashboard content title. The search group is centered on the whole panel
                        (page center) separately, below. */}
                    {!appConfig.isTempSite &&
                        <span
                            className={classes.taglineInline}
                            style={{ position:"absolute", left:"2rem", top:"50%", transform:"translateY(-50%)", margin:0 }}
                        >
                            Play, Create.
                        </span>
                    }
                </Grid>
                <Grid item xs={3}>
                    <Grid container justify="flex-end"  alignItems="center">
                    {(isLoggedIn === true) ?
                        <div style={{display: "inherit"}}>
                            <UserAvatar className={classes.avatar} avatar={this.state.avatar} name={getUsername()} size={35} />
                            <Button
                                onClick={()=>{
                                    EE.emit("Logged out")
                                    this.props.history.push({
                                        pathname: "/logout"
                                    })
                                }}
                                className={classes.logout}
                            >
                                    Log out
                            </Button>
                        </div>
                        :
                        <div>
                            <Button
                                onClick={()=>{
                                    this.props.history.push({
                                        pathname:"/login",
                                    })
                                }}
                                className={classes.logIn}
                            >
                                Log In
                            </Button>
                            <Button
                                onClick={()=>{
                                    this.props.history.push({
                                        pathname:"/register",
                                    })
                                }}
                                className={classes.signUp}
                            >
                                Be a jammer
                            </Button>
                        </div>
                    }
                    </Grid>
                </Grid>

                {/* Search + ABOUT — centered on the page */}
                <div className={classes.searchCenter}>
                    <Paper component="form" onSubmit={(e)=>{this.onSearch(e)}} className={classes.searchBar}>
                        <ClickAwayListener onClickAway={unfocusInputField("search-input")}>
                            <InputBase
                                id="search-input"
                                className={classes.searchInput}
                                placeholder="Join jam by ID"
                                inputProps={{style: {fontSize: "0.875rem", fontFamily:"arial"}}}
                                onChange={(e)=>{this.setState({searchString: e.target.value})}}
                            />
                        </ClickAwayListener>
                        <IconButton type="submit" className={classes.searchIcon} aria-label="search">
                            <Search />
                        </IconButton>
                    </Paper>
                    {!appConfig.isTempSite &&
                        <Link
                            href={frontpageConstants.links.introduction.src}
                            className={classes.links}
                        >
                            ABOUT
                        </Link>
                    }
                </div>
            </Grid>
         )

    }

    openMenu = (event) =>{
        this.setState({
            anchorEl : event.currentTarget
        })
    }

    closeMenu = () =>{
        this.setState({
            anchorEl : null
        })
    }


    onSearch = (e) => {
        e.preventDefault();
        window.location.href=`/game/${this.state.searchString}`
    }

}

export default withRouter(withApollo(withStyles(styles)(GameTopPanel)))
